<template>
  <div class="ProductModule overflow-hidden relative px-1 lg:px-2 h-full flex flex-col justify-between"
    :class="{ scaleView: $route.name !== 'sale' }">
    <router-link :to="{ name: 'sale', params: { category: routeType }, query: { tag: data.id } }" class="cursor-pointer" v-if="!data.type">
      <div class="outer">
        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">

          <img v-if="isLoaded"
            class="w-full h-full object-contain block"
            :alt="data.name"
            :src="computedCover"
          >
          <vue-content-loading :width="100" :height="100" v-if="data.cover && !isLoaded">
            <rect cx="30" cy="30" width="80" r="30" height="100" x="10" />
          </vue-content-loading>

        </div>
      </div>
    </router-link>
    <router-link :to="{ name: 'detail', params: { category: routeType, id: data.id } }" class="cursor-pointer" v-if="data.type">
      <div class="outer">
        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">

          <img v-if="isLoaded"
            class="w-full h-full object-contain block"
            :alt="data.name"
            :src="computedCover"
          >
          <vue-content-loading :width="100" :height="100" v-else>
            <rect cx="30" cy="30" width="80" r="30" height="100" x="10" />
          </vue-content-loading>

        </div>

        <!-- 數位軟體壓LOGO -->
        <div class="digi-mask mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute" v-if="data && data.is_digital && data.category_id && ['154', '160', '161', '162', '163', '155'].indexOf(data.category_id.toString()) > -1">
          <img src="~@/assets/icon/mask.png" class="w-full h-full object-contain mx-auto">
        </div>

      </div>
    </router-link>
    <div class="flex-grow flex flex-col justify-between py-2 md:pt-0 px-1 lg:px-2">
      <div class="w-full bg-white flex flex-col justify-between leading-normal">
        <div class="itemName mb-2">
          <div class="title text-base">
            <h5 class="text-NotoSansRegular whitespace-pre-wrap textColorBlack">{{ data.name }}</h5>
          </div>
        </div>
      </div>
      <div v-if="($route.params.category !== 'recent' && !$route.query.tag) || ($route.name === 'sale' && $route.query.tag) || ($route.name === 'groupBuyingTag')">
        <div class="text-xs flex items-center" v-if="data.status === 'DISCONTINUED' && data.category_id === 114">
        <p>限校園團購</p>
        </div>
        <div v-else class="flex items-center flex-wrap md:flex-no-wrap justify-between">
          <div class="period text-NotoSansLight w-full md:w-auto order-2 md:order-1 flex">
            <div class="price text-base">
              <p class="p-0 m-0 oldPprice textColorgray text-base text-center md:text-left flex items-center" v-if="data.type !== 'PLAN'">
                <span class="textColorRed mr-1 pt-2 whitespace-no-wrap hidden md:block">特價</span>
                <span class="textColorRed whitespace-no-wrap">$</span>
                <span class="newPrice textColorRed">{{ data.pricing }}</span>
              </p>
              <p class="p-0 m-0 oldPprice textColorgray text-base text-center md:text-left whitespace-no-wrap" v-else>
                <span class="newPrice textColorRed">{{ range_pricing }}</span>
              </p>
            </div>
          </div>

          <!-- 有庫存 -->
          <div class="cartwishbtns flex w-full justify-end md:w-auto order-1 md:order-2" v-if="data.type !== 'PLAN' && data.in_stock > 0 && data.status !== 'DISCONTINUED' && $route.name !== 'sale' && $route.name !== 'groupBuyingTag'">
            <div class="addcartBtn flex justify-center items-center px-2 cursor-pointer" @click.prevent="addCartFunc(data)" v-if="additionalForSubscribers.indexOf(data.id.toString()) === -1 && (data.gift_num === 0)">
              <div class="w-6 h-6">
                <img class="w-full object-contain" src="~@/assets/icon/cart.png" alt="Wish">
              </div>
            </div>
            <div class="addwishBtn flex justify-center items-center px-2 py-1 cursor-pointer" @click.prevent="addWishFunc(data)">
              <div class="w-6 h-6">
                <img class="w-full object-contain" src="~@/assets/icon/heart.png" alt="Wish" v-if="!data.is_favorite">
                <img class="w-full object-contain" src="~@/assets/icon/red.png" alt="Wish" v-if="data.is_favorite">
              </div>
            </div>
          </div>

          <!-- 補貨中 -->
          <div class="cartwishbtns flex w-full justify-end text-NotoSansLight  md:w-auto order-1 md:order-2" v-if="data.type !== 'PLAN' && (data.in_stock === 0 || data.in_stock === null) && data.status !== 'DISCONTINUED' && $route.name !== 'sale' && $route.name !== 'groupBuyingTag'">
            <p class="text-sm textColorRed border border-red-600 px-2 mr-2">補貨中</p>

            <div class="addwishBtn flex justify-center items-center px-2 py-1 cursor-pointer" @click.prevent="addWishFunc(data)">
              <div class="w-6 h-6">
                <img class="w-full object-contain" src="~@/assets/icon/heart.png" alt="Wish" v-if="!data.is_favorite">
                <img class="w-full object-contain" src="~@/assets/icon/red.png" alt="Wish" v-if="data.is_favorite">
              </div>
            </div>
          </div>

          <!-- 已絕版 -->
          <div class="OutPrint flex w-full justify-end text-NotoSansLight md:w-auto order-1 md:order-2" v-if="data.type !== 'PLAN' && data.status === 'DISCONTINUED' && $route.name !== 'sale' && $route.name !== 'groupBuyingTag'">
            <p class="text-sm textColorRed border border-red-600 px-2 mr-2">已絕版</p>
            <div class="addwishBtn flex justify-center items-center px-2 py-1 cursor-pointer invisible">
              <div class="w-6 h-6">
                <img class="w-full object-contain" src="~@/assets/icon/heart.png" alt="Wish" v-if="!data.is_favorite">
                <img class="w-full object-contain" src="~@/assets/icon/red.png" alt="Wish" v-if="data.is_favorite">
              </div>
            </div>
          </div>

          <!-- 訂閱 -->
          <div class="cartwishbtns flex w-full justify-end md:w-auto order-1 md:order-2" v-if="data.type === 'PLAN' && $route.name !== 'sale' && $route.name !== 'groupBuyingTag'">
            <div class="addwishBtn flex justify-center items-center px-2 py-1 cursor-pointer" @click.prevent="addWishFunc(data)">
              <div class="w-6 h-6">
                <img class="w-full object-contain" src="~@/assets/icon/heart.png" alt="Wish" v-if="!data.is_favorite">
                <img class="w-full object-contain" src="~@/assets/icon/red.png" alt="Wish" v-if="data.is_favorite">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="buyBtn flex justify-center w-full flex-col lg:flex-row px-4 pb-2" v-if="($route.name === 'sale' && $route.query && $route.query.tag) || ($route.name === 'groupBuyingTag')">
      <a v-if="data.type !== 'PLAN' && data.in_stock > 0 && data.status !== 'DISCONTINUED'" class="button-red btn cursor-pointer addCart text-NotoSansRegular py-2 w-full lg:w-3/4 mx-auto rounded text-center text-white"
        @click="addCartFunc(data)">
        加入購物車
      </a>
      <a v-if="data.type !== 'PLAN' && ((data.in_stock === 0 || data.in_stock === null) || data.status === 'DISCONTINUED')" class="bgLiveGray btn cursor-default addCart text-NotoSansRegular py-2 w-full lg:w-3/4 mx-auto rounded text-center text-white"
        >
        <span v-if="(data.in_stock === 0 || data.in_stock === null) && data.status !== 'DISCONTINUED'">補貨中</span>
        <span v-if="data.status === 'DISCONTINUED'">已絕版</span>
      </a>
      <router-link :to="{ name: 'detail', params: { category: routeType, id: data.id } }" v-if="data.type === 'PLAN'" class="button-red btn cursor-pointer addCart text-NotoSansRegular py-2 w-full lg:w-3/4 mx-auto rounded text-center text-white"
        @click="routeChange(item.id, item.type)">
        我要選購
      </router-link>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
/* eslint-disable no-unused-expressions */
import Cart from '@/components/modules/addCart'
import axios from 'axios'
import VueContentLoading from 'vue-content-loading'
import advertising from '@/components/modules/advertising'
import ga4 from '@/components/modules/ga4'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'ProductModule',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      isLoaded: false,

      // 限雜誌訂戶加購
      additionalForSubscribers: ['6743', '8848', '11175', '11174']
    }
  },
  components: {
    VueContentLoading
  },
  mixins: [
    Cart,
    advertising,
    ga4,
    sweetAlert
  ],
  watch: {
    '$props.data': {
      handler (newVal, oldVal) {
        if (newVal && newVal.cover) {
          this.onImageLoaded()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    range_pricing () {
      if (this.data.type === 'PLAN') {
        let arr = []
        for (let item of this.data.plan) {
          arr.push(item.pricing)
        }
        if (this.data.plan.length === 1) {
          return '$' + Math.min(...arr).toString()
        } else {
          return '$' + Math.min(...arr).toString() + ' - $' + Math.max(...arr).toString()
        }
      } else {
        return null
      }
    },
    routeType () {
      const { is_digital, type, category_name } = this.data

      if (is_digital) return 'digital'

      switch (type) {
        case 'PACKAGE':
          return category_name.includes('點讀') ? 'livepen' : 'package'
        case 'ITEM':
          return category_name.includes('點讀') ? 'recent' : 'package'
        case 'MAGAZINE':
        case 'PLAN':
          return 'magazine'
        case 'BOOK':
          return 'book'
        default:
          return 'recent'
      }
    },

    computedCover () {
      if (this.data && this.data.cover) {
        return this.data.cover
      } else {
        return require('@/assets/images/preset_item_small.png')
      }
    }
  },
  mounted () {
    this.onImageLoaded()
  },
  methods: {
    addCartFunc (data) {
      // this.addShoppingList(data)
      this.addMultipleToCart([data])
    },
    async addWishFunc(data) {
      const wishData = { productID: data.id, unit: '1' }

      if (!this.$store.state.auth.authorized) {
        return this.alertPop('warning', '尚未登入')
      }

      if (!data.is_favorite) {
        try {
          this.$set(this.data, 'is_favorite', true)

          await axios.post(`/products/${data.id}/favorite`)

          this.$emit('refreash', 'refreash')

          // 廣告商code
          if (this.data.type !== 'PLAN') {
            wishData.price = this.data.pricing
          }

          this.addWishCode(wishData)

          // GA
          this.add_to_wishlist(data)

          // 狀態切換
          if (this.$store.state.isAddWish) {
            await this.$store.dispatch('isAddingWish', false)
          }
          this.$store.dispatch('isAddingWish', true)

        } catch (err) {
          // 失敗就回復狀態
          this.$set(this.data, 'is_favorite', false)
          console.error(err)
        }

        return
      }

      try {
        this.$set(this.data, 'is_favorite', false)

        await axios.delete(`/products/${data.id}/favorite`)
        this.$emit('refreash', 'refreash')
      } catch (err) {
        this.$set(this.data, 'is_favorite', true)
        console.error(err)
      }
    },

    onImageLoaded () {
      if (!this.data.cover) {
        this.isLoaded = true
      } else {
        this.isLoaded = false
        var image = new Image()
        image.src = this.data.cover

        if (image.complete) {
          this.isLoaded = true
        } else {
          image.onload = () => {
            this.isLoaded = true
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .ProductModule {
    .progressiveImg {
      overflow: visible;
    }
    .item_borderB {
      border-bottom-width: 1px !important;
    }
    .outer {
      position: relative;
      width: 100%;
      background:white;
      display: block;
      &:after {
        content: "";
        display: block;
        padding-bottom: 100%;
      }
      .inner {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .itemName {
      .title {
        h5 {
          overflow:hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
      }
    }
    .period {
      .price {
        .oldPrice {
          font-weight: 900;
          color: #434343;
        }
        .newPrice {
          font-size: 24px;
            @media (max-width: 425px) {
              font-size: 18px;
            }
        }
      }
    }
    hr {
      border-top-color: #504f4f;
    }
  }
  .scaleView {
    transition: .2s;
    &:hover {
      position: relative;
      box-sizing: border-box;
      transform: scale(1.02);
      box-shadow: 0 1px 6px 0 rgba(0,0,0,0.4);
    }
  }
</style>
